import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'v2m-blog-switch-lang',
  templateUrl: './blog-switch-lang.component.html',
  styleUrls: ['./blog-switch-lang.component.scss']
})
export class BlogSwitchLangComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
